import styled from 'styled-components';
import { STATIC_IMAGE_URLS } from 'modules/core/constants';
import { WindowBreakpoints } from 'modules/core/enums/windowBreakpoints.enum';

export const LogoWrapper = styled.div<{
  isInMobileMenu?: boolean;
  isClickable: boolean;
}>`
  display: inline-block;
  height: 30px;
  width: 130px;
  margin: 6px 0;
  background: no-repeat left center url(${STATIC_IMAGE_URLS.logoWhite});
  background-size: contain;
  cursor: ${({ isClickable }) => isClickable && 'pointer'};

  margin-left: ${({ isClickable }) => isClickable && '10px'};

  @media (max-width: ${WindowBreakpoints.small}px) {
    margin-right: 5px;
    width: 123px;
  }
`;
